import moment, { Moment } from "moment";
import { DateFormat } from "../shared/constant";

const dateUtils = {
  defaultFormat: (date: object) => {
    if (date) return moment(date).format(DateFormat.DEFAULT);
    return "";
  },

  llMonthFormat: (date: object) => {
    if (date) return moment(date).format("ll");
    return "";
  },
  checkEndWithinOneYearSameMonth: (startDate: Moment, endDate: Moment) => {
    const oneYearLater = startDate.clone().add(1, "year");
    // Check if the end date is within 1 year from the start date and before or within the same month of the next year
    return endDate.isBetween(
      startDate,
      oneYearLater.endOf("month"),
      null,
      "[]",
    );
  },
};

export default dateUtils;
